import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import xclass from "../../../../assets/info/x-class-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import { popularVehicle } from "../../../../vars/popularVehicles";

const MercedesXClass = () => {
  useSmallNav("Mercedes X-Class");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Mercedes X-Class"} bolder />
        <InfoHero image={xclass} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Do you own and drive an X-Class? Looking for suspension parts or suspension upgrades?"
              }
            />
            <InfoHeader
              size="smaller"
              text={"Then you have come to the right place."}
            />
            <p>
              The new X-Class brings Mercedes to the 4x4 Pick-up market. And
              what an entry to that market!
            </p>
            <p>
              With coil springs all round, the new X-Class offers a step up from
              the more traditional pick-ups with their leaf springs.
            </p>
            <p>
              But, depending on how you use your vehicle, you may find your
              suspension needs modifying or improving.
            </p>
            <p>
              We offer lift kits for your X-Class for a more aggressive look and
              improved off-road ability, and also heavy duty kits for those
              putting their X-Class to work in more harsh enviroments, carrying
              heavy loads, and towing heavy equipment.
            </p>
            <p>
              All our kits feature Pedders Foam Cell shocks for the best
              possible performance. Please see the video to the right for full
              details of this technology.
            </p>
            <p>
              Not sure which kits or parts you require? Then please do get in
              touch, where one of our team will be able to assist you.
            </p>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/5F5cj3zCaCk"
              title={"Mercedes X-Class Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/-x9r6VqbGrg"
              title={"Mercedes X-Class Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"Mercedes X-Class Video 3"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Mercedes")
              .models.find((e) => e.display === "X-Class")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
          </div>
        </InfoGrid>
        {/* <InfoFooter make="Mercedes" model="X-Class" /> */}
      </Container>
    </section>
  );
};

export default MercedesXClass;
